import { Injectable } from '@angular/core';
import { CaeData, CaeDataService } from './cae-data.service';
import { MountingAssistantService } from '@configuration/assistants/mounting/mounting-assistant.service';
import { Log } from '@shared/debug/log';
import { RouteNavigationService } from '@services/route-navigation.service';
import { ProjectService } from '../components/import-export/service/project.service';
import { FileService } from '@shared/file/file.service';
import { CaeService } from './cae.service';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';
import { Observable } from 'rxjs';
import { ProjectModelService } from '../service/project-model.service';

@Injectable({ providedIn: 'root' })
export class CaeImportService {

  constructor(
    private caeDataService: CaeDataService,
    private mountingAssistantService: MountingAssistantService,
    private routeNavigationService: RouteNavigationService,
    private projectService: ProjectService,
    private fileService: FileService,
    private caeService: CaeService,
    private userActionsLoggingManager: UserActionsLoggingManager,
    private projectModelService: ProjectModelService,
  ) { }

  public async startCaeImportWithStorageId(storageId: string): Promise<void> {
    const caeDataObservable = this.caeDataService.importProjectsFromCaeByStorageId(storageId);
    await this.executeCaeImport(caeDataObservable);
  }

  public async startCaeImport(): Promise<void> {

    this.userActionsLoggingManager.logFunction('Cae_Import');

    if (!await this.projectService.checkConfirmCloseProject('main.import.title.confirm_import_project', 'main.import.message.confirm_import_project')) {
      return;
    }

    const file = await this.fileService.loadFileWithErrorHandling('.xml');
    if(!file) {
      return;
    }

    const caeDataObservable = this.caeDataService.importProjectsFromCae(await file.arrayBuffer());
    await this.executeCaeImport(caeDataObservable);
  }

  private async executeCaeImport(caeDataObservable: Observable<CaeData>): Promise<void> {
    const caeData = await this.caeService.validateProjectWithErrorHandling(caeDataObservable);
    if (!caeData) {
      return;
    }

    try {
      await this.routeNavigationService.toConfigurator();
    } catch (error) {
      Log.error('Could not navigate to configurator: ', error);
      return;
    }

    await this.projectModelService.clearCurrentProject(false);

    this.mountingAssistantService.start('cae', caeData);
  }
}
